import { gql } from '@apollo/client';

import { Assignment } from '../../types';
import { AssignmentFragment } from '../fragments';

export interface SendAssignmentMutationVariables {
  courseId: string;
  assignmentId: string;
  input: Record<string, any>;
}

export interface SendAssignmentMutationResult {
  assignment: Assignment;
}

export const sendAssignmentMutation = gql`
  mutation SendAssignmentMutation($courseId: String!, $assignmentId: String!, $input: AssignmentAnswerInput!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId, input: $input)
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}/send", method: "PUT") {
      ...Assignment
    }
  }
  ${AssignmentFragment}
`;
